import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom'
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery } from '@tanstack/react-query';
import ReactModal from 'react-modal';
import ImageWithLoader2 from './components/ImageWithLoader2';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import InfiniteScroll from "react-infinite-scroll-component";
import './styles/search-people.css';

function SearchPeople() {
  const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

  const navigate = useNavigate();
  
  const [selectedMember, setSelectedMember] = useState(null);

  const [searchModalOpen, setSearchModalOpen] = useState(false);


  const [searchImageModalOpen, setSearchImageModalOpen] = useState(false);

  const limit = 10;

  const [members, setMembers] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState("");

  const [isFetching, setIsFetching] = useState(false);


  const fetchMembers = async () => {

    if (isFetching) return;
    setIsFetching(true);

    try {
      const res = await axios.get(`${API_URL}/search-family-members-api`, {
        params: { page, limit, q: search },
        withCredentials: true,
      });
      const newData = res.data || [];

      setMembers(prev => [...prev, ...newData]);
      if (newData.length < limit) setHasMore(false);
    } catch (e) {
      console.error("fetch error:", e.response?.data || e.message);
      setHasMore(false);
    }finally {
      setIsFetching(false);
    }
  };

  // reset when search changes
  useEffect(() => {
    setMembers([]);
    setHasMore(true);
    setPage(1);
  }, [search]);

  // fetch on page/search changes
  useEffect(() => {
    fetchMembers();
    // eslint-disable-next-line
  }, [page, search]);

  const fetchNext = () => setPage(p => p + 1);

  const selectedIsPrivate =
  selectedMember?.is_private === true || selectedMember?.privacy === 'private';



  /*const AVATAR_PALETTE = [
    { bg: '#0d6e28', grad: 'linear-gradient(135deg,#e8f5ec,#c8e6d0)' },
    { bg: '#3a5fb0', grad: 'linear-gradient(135deg,#e8f0ff,#c5d5f5)' },
    { bg: '#b07a10', grad: 'linear-gradient(135deg,#fff8e1,#ffe082)' },
    { bg: '#6a3db0', grad: 'linear-gradient(135deg,#f3eeff,#d9c8f5)' },
    { bg: '#0a7a7a', grad: 'linear-gradient(135deg,#e0f7f7,#b2e8e8)' },
    { bg: '#b03030', grad: 'linear-gradient(135deg,#fdf0f0,#f5c6c6)' },
    { bg: '#8a5000', grad: 'linear-gradient(135deg,#fff3e0,#ffcc80)' },
  ];

  const avatarColor = (name = '') => {
    let h = 0;
    for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
    return AVATAR_PALETTE[Math.abs(h) % AVATAR_PALETTE.length];
  };
*/


const avatarColor = (name = '') => {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = name.charCodeAt(i) + ((h << 5) - h);
  }
  
  // 1. Get a stable hue between 0 and 360
  const hue = Math.abs(h) % 360;
  
  // 2. Generate a darker, rich tone for the initials background (e.g., Saturation: 65%, Lightness: 35%)
  const bg = `hsl(${hue}, 65%, 35%)`;
  
  // 3. Generate a soft, beautiful gradient for the outer wrap container
  const gradStart = `hsl(${hue}, 70%, 95%)`; // very light pastel
  const gradEnd = `hsl(${hue}, 60%, 85%)`;   // slightly deeper pastel
  const grad = `linear-gradient(135deg, ${gradStart}, ${gradEnd})`;

  return { bg, grad };
};
   
  const getInitials = (first = '', last = '') =>
    `${first?.charAt(0) || ''}${last?.charAt(0) || ''}`.toUpperCase();


  const [imageInfo, setImageInfo] = useState({});

  const handleImageLoad = (id, e) => {
    const img = e.target;
    const isPortrait = img.naturalHeight > img.naturalWidth;
    const isTallEnough = img.naturalHeight > 1300;
  
    setImageInfo(prev => ({
      ...prev,
      [id]: {
        isPortrait: isPortrait,
        cropTopHalf: isPortrait && isTallEnough
      }
    }));
  };

  
  return (
    <div className="scrollPageContainer theme-light">
      <div className="main-wrapper">
        {isSidebarVisible && <Sidebar />}
        <Header toggleSidebar={toggleSidebar} />
        <Sidebar show={showSidebar} toggle={toggleSidebar} />
        <Footerbar toggleSidebar={toggleSidebar} />

        <div className='page-wrapper'>
          <div className='content container-fluid' >

          <div
          id="scrollArea"
          className="contentx container-fluidx"
          style={{ height: "calc(100vh - 120px)", overflow: "auto", marginBottom: '20px' }}
        >
          
          <div className="row mt-2">
              <div className="col-12">
                <div
                  className="card border-0 shadow-sm rounded-4 mx-auto mb-3"
                  style={{ backgroundColor: '#F7FFF8', maxWidth: '520px' }}
                >
                  <div className="card-body p-3">
                    {/* Heading */}
                    <div className="text-center mb-2">
                      <h5 className="fw-bold text-dark mb-1">
                        <i className="bi bi-heart-fill text-success me-2"></i>
                        Search People
                      </h5>
                      <p className="text-muted small mb-0" style={{fontSize: '12.5px'}}>
                        Find and connect with people in your family network.
                      </p>
                    </div>

                    {/* Search */}
                     
                      <div
                        className="input-group rounded-pill overflow-hidden shadow-sm"
                        style={{  background: '#fff' }}
                      >
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search text-muted" />
                        </span>

                        <input
                          type="text"
                          className="form-control border-0 py-2 small"
                          placeholder="Search name"
                          value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          style={{ boxShadow: 'none', fontSize: '0.9rem' }}
                          aria-label="Search people"
                        />

                        
                      </div> 
                  </div>
                </div>
              </div>
            </div>


            <div className="row">

              <div className='col-md-12'>
             
            
        <div>
          
          {members.length === 0 && isFetching ? (
          <div className='loadingspinnerDiv'>
          <div className='loadingspinner'></div>
        </div>
        ) : (

          <InfiniteScroll
            dataLength={members.length}
            next={fetchNext}
            hasMore={hasMore}
            loader={
            <h4 className="text-center py-4">Loading...</h4>
          }
            endMessage={<p className="text-center py-4 text-gray-500"><b>No more results</b></p>}
            scrollableTarget="scrollArea"   
          >

<div className='row'>
  
            {members.map((member, idx) => (


    
    <div key={member.id} className="col-12 col-lg-6 d-flex justify-content-center mb-4">
  {(() => {
    const hasImage   = !!member.image_name;
    const isDeceased = !!member.date_of_death;
    const fullName   = `${member.name || ''} ${member.last_name || ''}`.trim();
    const color      = avatarColor(fullName);
    const initials   = getInitials(member.name, member.last_name);
    const isAdmin    = member.family_admin === 1;

    const imgFlags = imageInfo[member.id] || { isPortrait: false, cropTopHalf: false };

    return (

                    <article className="people-card-v3 clickable-card" >
                      <div className="people-card-v3-corner people-card-v3-corner-tl" />
                      <div className="people-card-v3-corner people-card-v3-corner-br" />

                      <h2 className="people-card-v3-title">  </h2>

                      <div className="people-card-v3-photo-wrap" 
                      /*style={{
                        background: hasImage
                          ? '#e8f0ea'
                          : isDeceased
                            ? 'linear-gradient(135deg,#f0f0f0,#ddd)'
                            : color.grad,
                      }}*/
                      >
    {hasImage ? (
      /* Image always fills the 280×280 box regardless of aspect ratio */
       
      <img
        src={`${API_URL}/images/${member.image_name}`}
        placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg" 
        alt={fullName}
        onLoad={(e) => handleImageLoad(member.id, e)}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          // If portrait and > 200px, span double height to show the top half
          height: imgFlags.cropTopHalf ? '200%' : '100%',
          // 'cover' handles the aspect ratio cropping, 'top' anchors it
          objectFit: 'cover',
          objectPosition: 'top',
          display: 'block',
        }}
      />
       
    ) : (
      /* Initials circle when no image */
      <div style={{
        width:          90,
      height:         90,
      borderRadius:   '50%',
      // No more hardcoded hex checks! It automatically takes the dynamic rich tone
      background:     isDeceased ? '#999' : color.bg, 
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center',
      fontSize:       32,
      fontWeight:     600,
      color:          '#fff',
      userSelect:     'none',
      // Generates a beautiful matching shadow by using the dynamic hsl string directly
      boxShadow:      `0 6px 18px ${isDeceased ? 'rgba(0,0,0,0.2)' : `${color.bg.replace(')', ', 0.35)')}`}`,
      zIndex:         1,
      }}>
        {initials}
      </div>
    )}

          </div>

                      

                      <h3 className="people-card-v3-name"> 
                        {member.n_prefix && `${member.n_prefix} `}
                        {member.name} {member.last_name}
                        {member.surname && ` ${member.surname}`}
                        </h3>

                      <div className="people-card-v3-dates">
                        
                      </div>

                      <button
            type="button"
            onClick={() => {
              setSelectedMember(member);
              setSearchImageModalOpen(true);
            }}
            style={{
              width:        '100%',
              padding:      '7px 0',
              borderRadius: 999,
              border:       'none',
              background:   isDeceased
                ? '#bbb'
                : 'linear-gradient(135deg,#0d6e28,#065c0c)',
              color:        '#fff',
              fontSize:     12,
              fontWeight:   500,
              cursor:       'pointer',
              transition:   'opacity 0.15s',
            }}
            onMouseEnter={e => { e.target.style.opacity = '0.85'; }}
            onMouseLeave={e => { e.target.style.opacity = '1'; }}
            title="View details"
          >
            View Details
          </button>

                    </article>

);
})()}
                  </div>
     


           
            ))}

            </div>

          </InfiniteScroll>

)}

          <div className='row end-page-space' style={{marginBottom: '5%'}}></div>
        </div>
        



        {selectedMember && (
<ReactModal
  isOpen={searchImageModalOpen}
  onRequestClose={() => setSearchImageModalOpen(false)}
  className="Modal"
  overlayClassName="Overlay"
  style={{
    overlay: {
     
      zIndex: 1050,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    content: {
      inset: 'auto',
      margin: 0,
      width: 'min(88vw, 332px)',
      maxHeight: '72vh',
      borderRadius: '14px',
      padding: 0,
      overflow: 'hidden',
      border: 'none',
      
      display: 'flex',
      flexDirection: 'column',
      background: '#fff',
    },
  }}
>
  
  {selectedMember && (
    <div className="w-100 h-100 d-flex flex-column">
      {/* Bigger banner */}
      <div
        className="position-relative"
        style={{
          minHeight: 130,
        }} >
       
      
       
<div
style={{
  position: "relative",
  height: "220px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  cursor: "grab", // Desktop hint
}}
>

  
{/* Overlay hint */}

<div
  style={{
    position: "absolute",
    top: "8px",
    left: "50%",
    width: "72%", 
    transform: "translateX(-50%)",
    background: "rgba(0,0,0,0.6)",
    color: "#fff",
    padding: "3px 8px",
    borderRadius: "4px",
    fontSize: "9px",
    zIndex: 2,
    animation: "fadeOut 2s 3s forwards", // Fades after 3s
  }}
>
  <center>
  Pinch to Zoom · Drag to Move
  </center>
  
</div>


{/* Optional zoom icon in corner */}
<div
  style={{
    position: "absolute",
    bottom: "8px",
    right: "8px",
    zIndex: 2,
  }}
>
  <i className="fas fa-search-plus" style={{ color: "#184A2C", fontSize: "12px" }}></i>
</div>


<button
  type="button"
  className="btn-close modalCloseButton"
  onClick={() => setSearchImageModalOpen(false)}
  style={{
    position: "absolute",
    top: "8px",
    right: "8px",
    zIndex: 3,
    borderRadius: "50%",
    padding: "4px",
  }}
></button>

<TransformWrapper
  doubleClick={{ mode: "zoomIn" }}
  pinch={{ disabled: false }}
  wheel={{ step: 0.1 }}
>
  <TransformComponent>
    <ImageWithLoader2
      src={`${API_URL}/images/${selectedMember.image_name}`}
      placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
      fadeDuration={800}
      blurAmount={15}
      alt={selectedMember.name}
      className=" top-0 start-0 w-100 h-100 object-fit-cover"
         style={{ opacity: 100, filter: 'grayscale(0%)' }} />
  </TransformComponent>
</TransformWrapper>

{/* Fade out animation */}
<style>
  {`
    @keyframes fadeOut {
      to {
        opacity: 0;
        visibility: hidden;
      }
    }
  `}
</style>
</div>
          

          

        
      </div>

      {/* Name */}
      <div className="px-2 pt-1">
        <div className="fw-semibold text-truncate" style={{ fontSize: '0.98rem' }}>
          {selectedMember.n_prefix}{' '}{selectedMember.name}{' '}
          {selectedMember.last_name}
        </div>
      </div>

      {/* Divider */}
      <div style={{ height: 6, background: '#fff' }} />

      {/* Body */}
      <div className="px-2 pb-1" style={{ overflowY: 'auto' }}>
        {selectedIsPrivate ? (
          <div className="text-center text-muted py-3 small">
            <i className="bi bi-lock me-1" />
            This member’s details are private.
          </div>
        ) : (
          <>
            {/* Top Stat Tiles — Family, Tribe (Age removed from tiles) */}
            <div
              className="d-grid mb-2"
              style={{ gridTemplateColumns: '1fr 1fr', gap: 8 }}
            >
              {[
                { label: 'Family', value: selectedMember.familyName },
                { label: 'Tribe', value: selectedMember.tribeName },
              ].map((it, i) => (
                <div
                  key={i}
                  className="text-center"
                  style={{
                    background: '#F3FBF5',
                    border: '1px solid #E4F2E9',
                    borderRadius: 12,
                    padding: '8px 6px',
                  }}
                >
                  <div className="text-muted" style={{ fontSize: '0.75rem' }}>{it.label}</div>
                  <div className="fw-bold" style={{ color: '#184A2C', fontSize: '0.9rem' }}>
                    {it.value || '—'}
                  </div>
                </div>
              ))}
            </div>

            {/* Bottom List — Age moved here, plus Sub-Tribe, Clan, Sub-Group, Totem */}
            <div
              className="rounded-4"
              style={{ background: '#FBFDFC', border: '1px solid #EEF6F0' }}
            >
              {[
                { label: 'Age', value: selectedMember.age },
                { label: 'Sub-Tribe', value: selectedMember.subtribeName },
                { label: 'Clan', value: selectedMember.clanName },
                { label: 'Sub-Group', value: selectedMember.subgroupName },
                { label: 'Totem', value: selectedMember.totemName },
              ].map((row, idx, arr) => (
                <div
                  key={idx}
                  className="d-flex align-items-center justify-content-between px-3"
                  style={{
                    padding: '6px 10px',
                    borderBottom: idx < arr.length - 1 ? '1px solid #EEF6F0' : 'transparent',
                  }}
                >
                  <span className="text-muted" style={{ fontSize: '0.75rem' }}>{row.label}</span>
                  <span
                    className="d-inline-flex align-items-center gap-2 fw-semibold"
                    style={{ color: '#0C5A2D', fontSize: '0.85rem' }}
                  >
                    <span>{row.value || '—'}</span>
                    {row.value && (
                      <span
                        aria-hidden
                        style={{
                          display: 'inline-block',
                          width: 14,
                          height: 2,
                          background: '#0C5A2D',
                          borderRadius: 2,
                        }}
                      />
                    )}
                  </span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="pt-2">

            <button 
            className="btn btn-primary w-100 text-white fw-semibold rounded-pill py-1"
            style={{
              
              border: 'none',
              boxShadow: '0 8px 18px rgba(24,74,44,0.25)',
              fontSize: '0.9rem',
            }}
            onClick={() => navigate('/chat', { state: { receiverId: selectedMember.id } })}>
              <i className="bi bi-chat-dots me-2" />
              Start Conversation
            </button>

             
            </div>
          </>
        )}
      </div>
    </div>
  )}
</ReactModal>
)}





</div>
            </div>

            </div>

            

          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchPeople;
